import { callExternalApi } from './external-api.service';
import { getLogger } from '../utils/logger';

const logger = getLogger('subscription-tracking.service');

export interface SubscriptionTrackingResponse {
  status: string;
  message: string;
}

/**
 * Track when user clicks the subscribe button
 * @param token - JWT access token
 * @returns Promise resolving to tracking response
 */
export const trackSubscribeClick = async (token: string) => {
  try {
    logger.debug('Tracking subscribe button click');

    const config = {
      url: `${process.env.REACT_APP_API_SERVER_URL}/api/subscription/track-click`,
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${token}`,
      },
      data: {},
    };

    const response = await callExternalApi({ config });

    if (response.error) {
      logger.error('Failed to track subscribe click', response.error);
      return { success: false, error: response.error };
    }

    logger.debug('Subscribe click tracked successfully', response.data);
    return { success: true, data: response.data };

  } catch (error) {
    logger.error('Error tracking subscribe click', error);
    return { success: false, error: { message: String(error) } };
  }
};
